import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ReportProducerComponent } from './report-producer.component';

@NgModule({
  declarations: [ReportProducerComponent],
  imports: [CommonModule, FormsModule, TranslateModule],
  exports: [ReportProducerComponent]
})
export class ReportProducerModule { }
